/**
 *
 * ResourceAndAssessmentDisclaimer
 *
 */

import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import ClassNames from 'classnames';

import injectSaga from 'utils/injectSaga';
import injectReducer from 'utils/injectReducer';
import AppContainer from 'components/AppContainer';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { makeSelectDisclaimer } from './selectors';
import { getDisclaimer } from './actions';
import reducer from './reducer';
import saga from './saga';

const styles = theme => ({
  root: {
    padding: '20px !important',
    marginTop: 33,
    boxShadow: 'none !important',
    background: '#fff',
    border: '1px solid #E2E2E2',
    borderRadius: 8,
    '& p, span': {
      color: theme.palette.text.primary,
      fontSize: 14,
      lineHeight: 1.57,
    },
  },
  assessmentsDisclaimer: {
    marginTop: 33,
    border: 'none',
  },
  content: {
    boxShadow: 'none',
    '& p': {
      display: 'inline',
      margin: 0,
    },
  },
  disclaimer: {
    fontWeight: 600,
  },
});

function ResourceAndAssessmentDisclaimer(props) {
  const { type, disclaimer, classes, page } = props;
  useEffect(() => {
    if (type && _isEmpty(disclaimer)) {
      props.getDisclaimer({ type });
    }
  }, [type]);

  const isAssessmentPage = page === 'assessments';
  if (_isEmpty(_get(disclaimer, 'items'))) return null;
  const content = (
    <Grid
      item
      xs={12}
      className={ClassNames(
        classes.root,
        isAssessmentPage ? classes.assessmentsDisclaimer : undefined,
      )}
    >
      <Paper className={classes.content}>
        <span className={classes.disclaimer}>Disclaimer: </span>
        {documentToReactComponents(disclaimer.items[0].fields.body)}
      </Paper>
    </Grid>
  );
  if (isAssessmentPage) return content;
  return (
    <div>
      <AppContainer>{content}</AppContainer>
    </div>
  );
}

ResourceAndAssessmentDisclaimer.propTypes = {
  classes: PropTypes.object,
  type: PropTypes.string,
  getDisclaimer: PropTypes.func,
  disclaimer: PropTypes.object,
  page: PropTypes.string,
};

const mapStateToProps = createStructuredSelector({
  disclaimer: makeSelectDisclaimer(),
});

function mapDispatchToProps(dispatch) {
  return {
    getDisclaimer: payload => dispatch(getDisclaimer(payload)),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

const withReducer = injectReducer({
  key: 'resourceAndAssessmentDisclaimer',
  reducer,
});
const withSaga = injectSaga({ key: 'resourceAndAssessmentDisclaimer', saga });

export default compose(
  withStyles(styles),
  withReducer,
  withSaga,
  withConnect,
)(ResourceAndAssessmentDisclaimer);
